import request from "superagent";
import { handleApiError } from "../utils/errors";
import { getAuthHeader } from "../utils/superagent";

export const getMetropolitanStatisticalAreas = async () => {
  const res = await request
    // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
    .get(`${global.api}/msa`)
    .set(await getAuthHeader())
    .query({ projection: ["name"] });
  return res.body;
};

// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'latitude' implicitly has an 'any' type.
export const getMSAByCoordinates = async (latitude, longitude, postalCode?: string) => {
  const res = await request
    // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
    .get(`${global.api}/msa/searchByCoordinates/${latitude},${longitude}?postalCode=${postalCode}`)
    .set(await getAuthHeader())
    .catch(handleApiError);
  return res && res.body;
};
